// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body, html, .main-app-container {
    margin: 0;
    padding: 0;
    height: 100%;
    width: 100%;
}

.main-app-container {
    /* Colors for the main-area, i.e. the graph view panel */
    --primary-bg-color: #fdfdfd;
    --primary-fg-color: #111;
    --primary-border-color: #999;
    --border-radius: 10px;
}

.span-link {
    color: #5c8aff;
    cursor: pointer;
}

.span-link:hover, span-link:focus {
    color: #2965ff;
    text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,wDAAwD;IACxD,2BAA2B;IAC3B,wBAAwB;IACxB,4BAA4B;IAC5B,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B","sourcesContent":["body, html, .main-app-container {\n    margin: 0;\n    padding: 0;\n    height: 100%;\n    width: 100%;\n}\n\n.main-app-container {\n    /* Colors for the main-area, i.e. the graph view panel */\n    --primary-bg-color: #fdfdfd;\n    --primary-fg-color: #111;\n    --primary-border-color: #999;\n    --border-radius: 10px;\n}\n\n.span-link {\n    color: #5c8aff;\n    cursor: pointer;\n}\n\n.span-link:hover, span-link:focus {\n    color: #2965ff;\n    text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
